import { useEffect } from "react";
import { useApp } from "../context/AppContext";
import RedesignView from "../views/RedesignView";

export default function StudioPage() {
  const ctx = useApp();

  useEffect(() => {
    ctx.setRedesignFiles([]);
    ctx.setRedesignError("");
    ctx.setRedesignParams(prev => ({ ...prev, focus: "", additional_notes: "", mode: "" }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <RedesignView
      files={ctx.files} redesignFiles={ctx.redesignFiles}
      toggleRedesignFile={ctx.toggleRedesignFile} redesignParams={ctx.redesignParams}
      setRedesignParams={ctx.setRedesignParams} redesignResult={ctx.redesignResult}
      redesignLoading={ctx.redesignLoading} redesignError={ctx.redesignError}
      handleRedesign={ctx.handleRedesign} refineInput={ctx.refineInput}
      setRefineInput={ctx.setRefineInput} refineLoading={ctx.refineLoading}
      handleRefine={ctx.handleRefine} savingRedesign={ctx.savingRedesign}
      handleSaveRedesign={ctx.handleSaveRedesign} applyToTermId={ctx.applyToTermId}
      setApplyToTermId={ctx.setApplyToTermId} applyingToCalendar={ctx.applyingToCalendar}
      handleApplyRedesignToCalendar={ctx.handleApplyRedesignToCalendar}
      setRedesignResult={ctx.setRedesignResult} setRedesignError={ctx.setRedesignError}
      terms={ctx.terms} downloadRedesign={ctx.downloadRedesign}
      downloadRedesignPDF={ctx.downloadRedesignPDF}
      activeTagFilter={ctx.activeTagFilter} setActiveTagFilter={ctx.setActiveTagFilter}
      redesignHistory={ctx.redesignHistory} redesignHistoryLoading={ctx.redesignHistoryLoading}
      loadRedesignHistory={ctx.loadRedesignHistory}
      fetchRedesignHistoryEntry={ctx.fetchRedesignHistoryEntry}
      deleteRedesignHistoryEntry={ctx.deleteRedesignHistoryEntry}
      folders={ctx.folders} sessionHistory={ctx.sessionHistory}
      sessionIndex={ctx.sessionIndex} setSessionIndex={ctx.setSessionIndex}
      setRedesignResultDirect={(result, index) => { ctx.setRedesignResult(result); ctx.setSessionIndex(index); }}
      activeHistoryEntryId={ctx.activeHistoryEntryId}
      handleSaveSyllabusToFolder={ctx.handleSaveSyllabusToFolder}
      savingToFolder={ctx.savingToFolder} setSavingToFolder={ctx.setSavingToFolder}
      saveToFolderMessage={ctx.saveToFolderMessage} setSaveToFolderMessage={ctx.setSaveToFolderMessage}
    />
  );
}